/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { MenuItem, MenuList } from '@mui/material';
import { useTranslation } from 'next-i18next';
import {
  AddCircleOutlineRounded,
  QueueMusicRounded,
} from '@mui/icons-material';

import { Playlist } from '@/infrastructure/class/playlist';
import { useAuth } from '@/infrastructure/context/auth-context';
import { usePlaylist } from '@/infrastructure/context/playlist-context';
import s from './styles.module.scss';

interface IPlaylistMenuProps {
  menuItemClassName?: string;
  onItemClick?: (playlist: Playlist) => void;
  handleClose?: () => void;
}

const PlaylistMenu: React.FC<IPlaylistMenuProps> = (props) => {
  const {
    menuItemClassName = '',
    onItemClick = () => {},
    handleClose = () => {},
  } = props;
  const { playlist, loadPlaylists } = usePlaylist();

  const { t: tButtons } = useTranslation('buttons');

  const { authUser, openCreatePlaylist } = useAuth();

  const menuItemClassNames = classNames(s['menu-item'], menuItemClassName);

  const openCreateModal = async () => {
    handleClose();
    openCreatePlaylist();
  };

  useEffect(() => {
    if (authUser) {
      (async () => {
        await loadPlaylists(authUser);
      })();
    }
  }, [authUser]);

  return (
    <MenuList>
      <MenuItem className={menuItemClassNames} onClick={openCreateModal}>
        <i>
          <AddCircleOutlineRounded />
        </i>
        {tButtons('createPlaylist')}
      </MenuItem>
      {playlist.items.map((playlist) => (
        <MenuItem
          key={playlist.id}
          className={menuItemClassNames}
          onClick={() => onItemClick(playlist)}
        >
          <i>
            <QueueMusicRounded />
          </i>
          {playlist.name}
        </MenuItem>
      ))}
    </MenuList>
  );
};

export default PlaylistMenu;
